
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import OutgoingInvoiceExportClassic from '@/views/OutgoingInvoice/OutgoingInvoiceExportClassic.vue';
import {
  OutgoingInvoiceEditModel,
  OutgoingInvoiceSettingsViewModel,
  OutgoingInvoiceViewModel
} from "@/services/api/nswag/stapiclient_generated";
import { outgoingInvoiceApi } from '@/services/st-api';
import OutgoingInvoiceExportModern from '@/views/OutgoingInvoice/OutgoingInvoiceExportModern.vue';
import OutgoingInvoiceExportOther from '@/views/OutgoingInvoice/OutgoingInvoiceExportOther.vue';
import OutgoingInvoiceExportOther2 from '@/views/OutgoingInvoice/OutgoingInvoiceExportOther2.vue';

@Component({
  components: {
    OutgoingInvoiceExportClassic,
    OutgoingInvoiceExportModern,
    OutgoingInvoiceExportOther,
    OutgoingInvoiceExportOther2,
  },
})
export default class OutgoingInvoiceExport extends Vue {
  @Prop() outsideId?: number;
  @Prop() editModel?: OutgoingInvoiceEditModel;

  settingsModel: OutgoingInvoiceSettingsViewModel = OutgoingInvoiceSettingsViewModel.fromJS({});

  id: number = 0;
  model: OutgoingInvoiceViewModel = OutgoingInvoiceViewModel.fromJS({});
  logoUrl: string = '';

  get layoutDefault() {
    return !this.layout || this.layout == 'Classic';
  }

  get layout() {
    return this.editModel?.layoutName?.toString() ?? this.model.layoutName?.toString();
  }

  created() {
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id);
    }

    if (this.outsideId) {
      this.id = this.outsideId;
    }
  }

  get finalDescription() {
    let res = this.model?.description;

    if (!res) {
      return '';
    }

    return res
      .replace('{DatumVon}', this.model?.dateFromPlaceholder ?? '')
      .replace('{DatumBis}', this.model?.dateToPlaceholder ?? '')
      .replace('{Ansprechpartner}', this.model?.contactNamePlaceholder ?? '');
  }

  @Watch('model.id')
  async idChanged() {
    let file = await outgoingInvoiceApi.getLogo(this.model.id ?? 0);

    if (!!file?.data?.size) {
      this.logoUrl = URL.createObjectURL(file.data);
    }
  }

  async mounted() {
    this.settingsModel = await outgoingInvoiceApi.getSettingsViewModel();

    if (!!this.editModel) {
      this.model = await outgoingInvoiceApi.getViewModelFromEditModel(this.editModel);
    } else if (this.id) {
      this.model = await outgoingInvoiceApi.getViewModel(this.id);
    }
  }
}
